import React from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function WaitlistSection({
    userRole,
    waitlistEntries,
    handlePromoteFromWaitlist,
    handleOpenProfile,
    isPromotingFromWaitlist
}) {
    if (userRole !== "affiliate" && userRole !== "trainer") {
        return null;
    }

    if (waitlistEntries.length === 0) {
        return null;
    }

    return (
        <>
            <Typography variant="h6" sx={{ fontWeight: "bold", marginTop: 3, marginBottom: 1 }}>
                Waitlist ({waitlistEntries.length})
            </Typography>
            <List>
                {waitlistEntries.map((entry, index) => (
                    <ListItem
                        key={entry.id}
                        sx={{
                            border: "2px solid #f0f0f0",
                            borderRadius: "8px",
                            padding: "12px",
                            marginBottom: "8px",
                            backgroundColor: "#f9f9f9"
                        }}
                    >
                        <ListItemText
                            primary={
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography
                                        sx={{
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            color: "blue",
                                            "&:hover": { textDecoration: "underline" }
                                        }}
                                        onClick={() => handleOpenProfile(entry.userId)}
                                    >
                                        {entry.user.fullName}
                                    </Typography>
                                </Box>
                            }
                            secondary={
                                <>
                                    <Typography variant="caption">
                                        Added to waitlist: {new Date(entry.createdAt).toLocaleString()}
                                    </Typography>
                                    <br />
                                    <Typography variant="caption">
                                        Plan: {entry.userPlan?.planName || "Free Class"}
                                    </Typography>
                                    <br />
                                    <Typography variant="caption">
                                        Sessions left: {entry.userPlan?.sessionsLeft ?? "N/A"}
                                    </Typography>
                                    {entry.familyMember && (
                                        <>
                                            <br />
                                            <Typography variant="caption">
                                                Family Member Registration
                                            </Typography>
                                        </>
                                    )}
                                </>
                            }
                        />

                        <ListItemSecondaryAction>
                            <IconButton
                                onClick={() => handlePromoteFromWaitlist(entry.id)}
                                color="primary"
                                size="small"
                                disabled={isPromotingFromWaitlist === entry.id}
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                    }
                                }}
                            >
                                {isPromotingFromWaitlist === entry.id ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <AddIcon />
                                )}
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        </>
    );
}

